import {DataTable, useDataTableStorage, useSpringPage, useSpringPageable} from "@variocube/app-ui";
import React, {useMemo} from "react";
import {useAsync} from "react-async-hook";
import {useTenantUserApi} from "../../api";
import {EmptyList} from "../../controls";
import {useLocalization, useWordingFlavor} from "@smalox/shared";
import {useParam} from "../../utils/useParam";
import {BookingCell} from "../booking/BookingCell";
import {BookingCompartmentCell} from "../booking/BookingCompartmentCell";
import {BookingFromCell} from "../booking/BookingFromCell";
import {BookingLocationCell} from "../booking/BookingLocationCell";
import {BookingRetrievalConfirmation} from "../booking/BookingRetrievalConfirmation";
import {BookingUntilCell} from "../booking/BookingUntilCell";

export function UserBookingList() {
	return (
		<BookingRetrievalConfirmation>
			<UserBookingListConfirmed />
		</BookingRetrievalConfirmation>
	);
}

export function UserBookingListConfirmed() {
	const {t} = useLocalization();
	const wordingFlavor = useWordingFlavor();
	const username = useParam("username");

	const {getUserBookings} = useTenantUserApi();

	const columns = useMemo(() => [
		{
			label: t(`bookings.single.${wordingFlavor}`),
			field: "id",
			sortable: true,
			default: true,
			component: BookingCell,
		},
		{
			label: t("bookings.from"),
			field: "from",
			sortable: true,
			default: true,
			component: BookingFromCell,
		},
		{
			label: t("bookings.until"),
			field: "until",
			sortable: true,
			default: true,
			component: BookingUntilCell,
		},
		{
			label: t("bookings.location"),
			field: "location.name",
			sortable: true,
			default: true,
			component: BookingLocationCell,
		},
		{
			label: t(`bookings.compartment.${wordingFlavor}`),
			field: "compartment.number",
			sortable: true,
			default: true,
			component: BookingCompartmentCell,
		},
	], [t, wordingFlavor]);

	const {onPageChange, onSort, ...storage} = useDataTableStorage("BookingList.paging");
	const pageable = useSpringPageable(storage);

	const {loading, error, result} = useAsync(getUserBookings, [username, pageable]);
	const {rows, page} = useSpringPage(result);

	return (
		<DataTable
			columns={columns}
			rows={rows}
			page={page}
			loading={loading}
			error={error}
			onSort={onSort}
			onPageChange={onPageChange}
			empty={<EmptyList />}
			{...storage}
		/>
	);
}
